import React from 'react';

export default props => {
    return (
        <svg viewBox="0 0 10 10" {...props}>
            <rect x="0.5" y="3.5" width="6" height="6" fill="none" strokeWidth="1"/>
            <rect x="3.5" y="0.5" width="6" height="6" fill="none" strokeWidth="1"/>
        </svg>
    );
};
